

































































































import PageHeader from "@/components/PageHeader.vue";
import { Vue, Component, Watch } from "vue-property-decorator";
import { Action, State } from "vuex-class";
import ViewAgents from "@/components/Agents/ViewAgents.vue";
import AgentCalls from "@/components/Agents/AgentCalls.vue";
import ManageAgent from "@/components/Agents/ManageAgent.vue";
import ActiveCallCard from "@/components/Agents/ActiveCallCard.vue";
import EnqueuedCalls from "@/components/Agents/EnqueuedCalls.vue";
import VerificationAdminView from "@/components/Agents/VerificationAdminView.vue";
import { getUserId } from "@/helpers";
import { collections, firestore } from "@/configs/firebase";
import logger from "../configs/logger";
import moment from "moment";
import { User, AgentsFilterToggle, Features } from "@/types";
import featureConfig from "@/helpers/featureConfigs";
import { pickBy } from "lodash";
import { checkFeatureAccess } from "@/helpers/permissions";

@Component({
  components: {
    PageHeader,
    ViewAgents,
    AgentCalls,
    ActiveCallCard,
    ManageAgent,
    EnqueuedCalls,
    VerificationAdminView
  }
})
export default class Agents extends Vue {
  @Action("unbindLiveCalls") unbindLiveCalls!: Function;
  @Action("bindLiveCalls") bindLiveCalls!: Function;
  @Action("getCallHistory") getCallHistory!: Function;
  @Action("bindEnqueuedCalls") bindEnqueuedCalls!: Function;
  @Action("unbindEnqueuedCalls") unbindEnqueuedCalls!: Function;
  @State("liveCalls") liveCalls!: any[];
  @State("enqueuedCalls") enqueuedCalls!: any[];
  @State("user") user!: User;
  @State("access") userAccess!: any;

  selected: any = {};
  callHistory: any[] = [];
  loadingCallHistory = false;
  groupAgents: any = {};
  unsubscribeAgents!: Array<Function>;
  toggleOnline: AgentsFilterToggle = "online";
  filteredGroupAgents: any = {};
  groupsSelectItems: string[] = [];
  groupsSelectValues: string[] = [];

  @Watch("groupAgents")
  onGroupAgentChange() {
    this.updateFilteredAgents();
  }

  @Watch("toggleOnline")
  onButtonFilterChange() {
    this.updateFilteredAgents();
  }

  @Watch("groupsSelectValues")
  onSelectFilterChange() {
    this.updateFilteredAgents();
  }

  get totalAgents() {
    return Object.values(this.groupAgents).flatMap((item: any) => item.agents)
      .length;
  }

  get totalOnlineAgents() {
    return Object.values(this.groupAgents)
      .flatMap((item: any) => item.agents)
      .filter((agent: any) => this.isAgentOnline(agent) && agent).length;
  }

  get totalOfflineAgents() {
    return Object.values(this.groupAgents)
      .flatMap((item: any) => item.agents)
      .filter((agent: any) => !this.isAgentOnline(agent) && agent).length;
  }

  get hasVerificationAdminAccess() {
    return checkFeatureAccess(Features.VerificationAdmin, {
      access: this.userAccess,
      roles: this.user.roles
    });
  }

  get isAdmin() {
    return this.user.roles.includes("admin");
  }

  get agents() {
    return Object.values(this.groupAgents).flatMap((item: any) => item.agents);
  }

  get groups() {
    if (this.isAdmin) {
      return featureConfig.getGroupTypes();
    }
    return featureConfig
      .getGroups(this.user.groups)
      .filter(group => !!group.groupSupervising)
      .map(group => group.groupSupervising);
  }

  beforeDestroy() {
    this.unbindLiveCalls();
    this.unbindEnqueuedCalls();
    if (Array.isArray(this.unsubscribeAgents)) {
      this.unsubscribeAgents.forEach(unsub => unsub());
    }
  }

  mounted() {
    this.$nextTick(() => {
      this.getAgents();
      this.bindLiveCalls();
      //this.bindEnqueuedCalls();
    });
  }

  getCall(agent: any) {
    const uid = agent ? getUserId(agent) : "";
    return this.liveCalls.find(
      call =>
        call.reservation_user_key === `user/${uid}` &&
        call.agent_call_sid != null
    );
  }

  isAgentOnline(agent: any): boolean {
    if (
      agent.active_task_attribute_key ||
      agent.available ||
      this.getCall(agent)
    ) {
      return true;
    }
    return false;
  }

  getAgents() {
    const subAgents = (groupOrRole: string, name: string) => {
      return collections.user
        .where(groupOrRole, "array-contains", name)
        .onSnapshot(snapshot => {
          const agents = snapshot.docs.map(doc => {
            const data = { id: doc.id, ...doc.data() };
            this.trackSelectedAgent(data);
            return data;
          });
          this.groupAgents = {
            ...this.groupAgents,
            [name]: {
              agents,
              group: name
            }
          };
          this.filteredGroupAgents = this.groupAgents;
          this.groupsSelectItems = [...this.groupsSelectItems, name];
        });
    };

    this.unsubscribeAgents = this.groups.map((group: any) =>
      subAgents("groups", group)
    );
    if (this.isAdmin) {
      this.unsubscribeAgents = [
        ...this.unsubscribeAgents,
        subAgents("roles", "admin")
      ];
    }
  }

  onRemoveGroupFilter(item: string) {
    this.groupsSelectValues = this.groupsSelectValues.filter(
      (value: string) => value !== item
    );
  }

  updateFilteredAgentsByGroup() {
    const copiedFilteredGroupAgents = JSON.parse(
      JSON.stringify(this.filteredGroupAgents)
    );

    const cleanedByGroupAgents = pickBy(copiedFilteredGroupAgents, (_, key) =>
      this.groupsSelectValues.includes(key)
    );

    this.filteredGroupAgents = cleanedByGroupAgents;
  }

  updateFilteredAgents() {
    if (this.toggleOnline === "online") {
      const copiedGroup = JSON.parse(JSON.stringify(this.groupAgents));
      Object.keys(copiedGroup).forEach((key: string) => {
        copiedGroup[key].agents = copiedGroup[key].agents.filter(
          (agent: any) => this.isAgentOnline(agent) && agent
        );
      });

      this.filteredGroupAgents = copiedGroup;
    } else if (this.toggleOnline === "offline") {
      const copiedGroup = JSON.parse(JSON.stringify(this.groupAgents));
      Object.keys(copiedGroup).forEach((key: string) => {
        copiedGroup[key].agents = copiedGroup[key].agents.filter(
          (agent: any) => !this.isAgentOnline(agent) && agent
        );
      });
      this.filteredGroupAgents = copiedGroup;
    } else {
      this.filteredGroupAgents = this.groupAgents;
    }

    // run group filter here
    if (this.groupsSelectValues.length > 0) {
      this.updateFilteredAgentsByGroup();
    }
  }

  trackSelectedAgent(agent: any) {
    // when document updates we want to know the item selected before that update
    if (this.selected && this.selected.id) {
      if (this.selected.id == agent.id) {
        this.selected = agent;
      }
    }
  }

  selectAgent(agent: any) {
    this.selected = agent;
    this.fetchCallHstory(agent);
  }

  async fetchCallHstory(user: any) {
    try {
      this.loadingCallHistory = true;
      this.callHistory = await this.getCallHistory(getUserId(user));
    } finally {
      this.loadingCallHistory = false;
    }
  }

  get selectedAgentActiveCall() {
    return this.liveCalls.find(
      call =>
        call.reservation_user_key === `user/${getUserId(this.selected)}` &&
        call.agent_call_sid != null &&
        !call.call_ended
    );
  }

  get callsInQueue() {
    return this.enqueuedCalls.filter(item => {
      // ignore tasks stuck in queue
      moment.unix(item.created_ts.seconds).hours() < 1;
    }).length;
  }
}
